import { parseInboundPayload } from '../inbound';
import { createArrayWithBracesParser, numberParser } from '../inboundParsers';
import { splitWithBraces, trimBraces } from '../inboundUtils';
import { lastActionParser } from './utils/lastActionInboundUtils';
import { revealedCardsParser, seatIndexParser } from './utils/pokerInboundUtils';
export const SHOW_ALL_IN_HANDS_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'currNumHoleCards', parser: numberParser },
        { name: 'allInPlayerHands', parser: createArrayWithBracesParser(allInPlayerHandParser) },
        { name: 'lastAction', parser: lastActionParser }
    ]
};
function allInPlayerHandParser(str) {
    const inboundParts = splitWithBraces(trimBraces(str));
    return parseInboundPayload(inboundParts, allInPlayerHandPartDefinitions);
}
const allInPlayerHandPartDefinitions = [
    { name: 'seatIndex', parser: seatIndexParser },
    { name: 'chipsBetLastRound', parser: numberParser },
    { name: 'numChips', parser: numberParser },
    { name: 'revealedCards', parser: revealedCardsParser }
];
